/* eslint-disable no-console */
import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormBuilder, NgForm } from '@angular/forms';

import { ContactType } from '../../constants/contact-type.constants';
import { NgxSpinnerService } from 'ngx-spinner';
import { AbstractFormComponent } from '../abstract-form.component';

/**
 * Contact Form Component
 * @description Angular Utility Component. Show input text for contact insertion
 */
@Component({
  selector: 'ap-modal-contact-form',
  templateUrl: './contact-form.component.html',
  styles: ['.form-group .col p {line-height: 15px; font-size: 14px;}'],
  viewProviders: [NgForm],
})
export class ContactFormComponent extends AbstractFormComponent implements AfterViewInit {
  @Input() contactValue?: string;
  @Input() cType?: ContactType;
  @Input() descriptionText?: string;
  @Input() contactLabelText?: string;
  @Input() mobileErrorText?: string;
  @Input() submitButtonText?: string;
  @Input() backButtonTxt?: string;
  @Input() backButtonVisible?: boolean;

  @Output() onContactSubmitted = new EventEmitter<string>();
  @Output() onGoBackClicked = new EventEmitter<void>();

  contactTypes = ContactType;

  mobileRealValue = '';

  contactForm = this.fb.group(
    {
      contact: [''],
    },
    { updateOn: 'blur' }
  );

  constructor(private readonly fb: UntypedFormBuilder, protected ngxSpinner: NgxSpinnerService) {
    super(ngxSpinner);
  }

  getSpinnerName(): string {
    return 'contactFormBtn';
  }

  /**
   * Component inizialization
   * Fill input if father component configure a contact placeholder
   */
  ngAfterViewInit(): void {
    if (this.contactValue) {
      setTimeout(() => {
        this.contactForm.patchValue({ contact: this.contactValue });
      });
    }
  }

  /**
   * Method used for retrieve the contact value
   */
  getValue(): string {
    return this.contactForm.get('contact')?.value;
  }

  /**
   * After form submission, return value to parent component
   */
  submitContact(): void {
    let contact = this.getValue();
    if (this.cType === ContactType.MOBILE) {
      contact = this.mobileRealValue;
    }
    this.onContactSubmitted.next(contact);
  }

  /**
   * After mobile submitted. @see InputMobileComponent
   */
  mobileSubmitted(value: string): void {
    this.mobileRealValue = value;
  }

  /**
   * If user require to go back to previous step or just ask to close the modal if there are no previous steps
   */
  goBack(): void {
    this.onGoBackClicked.next();
  }
}
